module.exports = __webpack_public_path__ + "8407baf61c40795765b3e5aa8d7bd3e7.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/labels/nose-bold.svg
// module id = s7z7
// module chunks = 0